import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';

export const gkApi = createApi({
  reducerPath: 'gkApi',
  baseQuery,
  endpoints: () => ({}),
  tagTypes: [
    'EVENT_LIST',
    'MARKT_CUSTOMER_LIST',
    'MARKT_STOCK',
    'STOCK',
    'TODO_LIST',
    'TODO',
    'TODO_CATEGORY',
    'CONTINGENT_LIST',
    'CONTINGENT_STATUS',
    'CREW_DELIVERY_TEMPLATE_LIST',
    'LOGBOOK_LIST',
    'RESERVATION_LIST',
    'INVENTORY_COUNT',
    'CASH_REGISTER_LIST',
    'CASH_SESSION_LIST',
    'CASH_SESSION',
    'CASH_TX_LIST',
    'BACKSTAGE_DELIVERY_PLAN',
    'BAR_DELIVERY_LIST',
    'BAR_DELIVERY',
    'LOCATION_LIST',
  ],
});
